import {FC} from 'react'
import {DialogHeading, DialogStore} from '@ariakit/react'
import {ConfirmationDialog} from '@/components/ui/confirmation-dialog-atoms/ConfirmationDialogAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {useTranslation} from '@/translations/i18n.tsx'

interface ImpersonateConfirmationDialogProps {
    dialogStore: DialogStore
    fullName: string
    email: string
    onConfirm: () => void
    isConfirmPending: boolean
}

export const ImpersonateConfirmationDialog: FC<ImpersonateConfirmationDialogProps> = ({
    dialogStore,
    fullName,
    email,
    onConfirm,
    isConfirmPending
}) => {
    const {t} = useTranslation()

    return (
        <ConfirmationDialog
            dialogStore={dialogStore}
            onConfirm={onConfirm}
            isConfirmPending={isConfirmPending}
            confirmButtonText={t('impersonation:confirm_button')}
            hideDialogBody
            headerSlot={
                <Flexbox direction="column">
                    <DialogHeading>{t('impersonation:confirmation_title', {fullName})}</DialogHeading>
                    <Text palette="neutral" shade="500" size="textSm">
                        {email}
                    </Text>
                </Flexbox>
            }
            contentSlot={
                <Text palette="neutral" shade="950" size="textSm">
                    {t('impersonation:confirmation_description')}
                </Text>
            }
        />
    )
}
